import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    rptcf(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['layout', 'tgl1', 'tgl2', 'calcMode'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/cashflwindi/rptcf${str}`;
                const { data } = await axios.get(url);
                resolve(data[0]);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    rptcfexport(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['layout', 'tgl1', 'tgl2', 'calcMode'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                let response = await axios({
                    url: `/cashflwindi/rptcfexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Cashflow_indirect_${obj.tgl2}.xlsx`);
                document.body.appendChild(link);
                link.click();
                resolve(link);
            } catch (error) {
                let responseObj = await error.response.data.text();
                errorHandler(JSON.parse(responseObj), reject);
            }
        });

    },
    rptcfprint(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['layout', 'tgl1', 'tgl2', 'calcMode'];

                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                const url = `/cashflwindi/rptcfprint${str}`;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });

    },
    rptkodekolom() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`cashflwindifmt/rptkodekolom`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    layout(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                // const { data } = await axios.get(`cashflwindi/layout/${encodeURIComponent(obj.layout)}`);
                const { data } = await axios.get(`cashflwindifmt/${encodeURIComponent(obj.layout)}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    layout_combo() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`cashflwindifmt/combo`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    layoutDel(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.delete(`cashflwindifmt/${encodeURIComponent(obj.layout)}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    layoutSave(data) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post("cashflwindifmt", data);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }

};